import React, { useEffect, useState } from 'react'
import { loadingState } from 'src/atom/LoadingState'
import { useRecoilState } from 'recoil'
import { Link, useLocation } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { FaUserShield, FaArrowLeft } from 'react-icons/fa'
import { verifyUserID } from 'src/services/Login/ForgotPassword'
import LogoHeader from 'src/components/header/LogoHeader'

const ForgotPassword = () => {
  const [, setShowResendButton] = useState(false)
  const [, enableLoader] = useRecoilState(loadingState)
  const [countdown, setCountdown] = useState(120)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const navigate = useNavigate()

  const userObject = {
    userId: '',
  }
  const [formData, setFormData] = useState(userObject)
  const [success, ] = useState('')
  const [validationErrors,] = useState({
    userId: '',
  })

  const handleUserIdOnchange = (event) => {
    const value = event.target.value
    setFormData((prevFormData) => ({
      ...prevFormData,
      userId: value,
    }))
  }

  const handleProceed = async () => {
    enableLoader(true)
    setIsSubmitting(true)
    try {
      const response = await verifyUserID(formData.userId)
      if (response.success === true) {
        const bodyValues = Object.values(response.body)

        navigate('/validate-password', {
          state: { token: bodyValues, userId: formData.userId },
        })
      } else {
        toast.error(response.message, {
          position: 'top-center',
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'colored',
        })
      }
    } catch (error) {
      toast.error(error.message, {
        position: 'top-center',
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'colored',
      })
    } finally {
      enableLoader(false)
      setIsSubmitting(false)
    }
  }

  useEffect(() => {
    let timer = null
    if (countdown > 0) {
      timer = setTimeout(() => {
        setCountdown(countdown - 1)
      }, 1000)
    } else {
      setShowResendButton(true)
    }
    return () => clearTimeout(timer)
  }, [countdown])

  return (
    <>
      <div className="card" style={{ border: 'none', borderRadius: 0 }}>
        <LogoHeader />
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '70vh',
          backgroundColor: '#f4f4f4',
          padding: '2rem 1rem',
        }}
      >
        <div
          style={{
            width: '100%',
            maxWidth: '460px',
            backgroundColor: '#ffffff',
            borderRadius: '18px',
            boxShadow: '0 12px 32px rgba(0, 0, 0, 0.1)',
            overflow: 'hidden',
          }}
        >
          <div
            style={{
              backgroundColor: '#3C4B64',
              padding: '24px 28px',
              display: 'flex',
              alignItems: 'center',
              gap: '14px',
            }}
          >
            <div
              style={{
                width: '48px',
                height: '48px',
                minWidth: '48px',
                borderRadius: '50%',
                backgroundColor: '#4d5f7c',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <FaUserShield size={22} color="#ffffff" />
            </div>
            <div>
              <p style={{ color: '#ffffff', fontSize: '1.1rem', fontWeight: 700, margin: 0 }}>
                Retrieve Password
              </p>
              <p style={{ color: '#C9D1DB', fontSize: '0.8rem', margin: 0 }}>
                We&apos;ll send an OTP to verify your identity
              </p>
            </div>
          </div>

          <div style={{ padding: '28px' }}>
            <label style={{ color: '#374151', fontSize: '0.9rem', marginBottom: '10px', display: 'block' }}>
              Enter your Username to receive an OTP
            </label>

            {success && (
              <div style={{ color: '#DC2626', fontSize: '0.85rem', marginBottom: '10px' }}>{success}</div>
            )}

            <div style={{ display: 'flex', gap: '10px' }}>
              <input
                type="text"
                className={`form-control ${validationErrors.userId ? 'is-invalid' : ''}`}
                id="userId"
                pattern="^(?!$)[a-zA-Z0-9_]+$"
                placeholder="Enter Username"
                value={formData.userId}
                onChange={handleUserIdOnchange}
                style={{ padding: '10px 14px', border: '1px solid #E5E7EB', borderRadius: '8px' }}
              />
              <button
                type="button"
                onClick={handleProceed}
                disabled={!formData.userId || isSubmitting}
                style={{
                  backgroundColor: '#3C4B64',
                  color: '#ffffff',
                  border: 'none',
                  borderRadius: '8px',
                  padding: '10px 20px',
                  fontWeight: 500,
                  whiteSpace: 'nowrap',
                  opacity: !formData.userId || isSubmitting ? 0.6 : 1,
                }}
              >
                {isSubmitting ? 'Proceed...' : 'Proceed'}
              </button>
            </div>
            {validationErrors.userId && (
              <div style={{ color: '#DC2626', fontSize: '0.8rem', marginTop: '6px' }}>
                {validationErrors.userId}
              </div>
            )}

            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
              <Link
                to="/login"
                style={{
                  color: '#3C4B64',
                  fontSize: '0.9rem',
                  textDecoration: 'none',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                }}
              >
                <FaArrowLeft size={12} /> Back to Login
              </Link>
            </div>
          </div>
        </div>
      </div>

      <ToastContainer />
    </>
  )
}

export default ForgotPassword